<template>
    <div>
        <!--提示标题栏-->
        <div style="width: 88%;height: 40px;line-height:40px;">
            <div style="
            background-color: #adadad;
            width: 150px;
            height: 40px;
            text-align: center;
            vertical-align: middle;
            float: left;">
                每日特价配置
            </div>
            <div style="
            background-color: #adadad;
            margin-left: 2px;
            width: 35%;
            height: 40px;
            text-align: center;
            color: #adadad;
            float: left;">
                每日特价配置
            </div>
        </div>
        <!--查询当前已经配置的每日特价-->
            <el-form :model="seckillAppInfo" :rules="rules" ref="seckillAppInfo" label-width="150px" class="demo-ruleForm">
                <el-form-item label="商品名称" prop="sku" >
                    <el-col :span="8">
                        <el-input v-model="seckillAppInfo.app_name"   :disabled="true"  ></el-input>
                    </el-col>
                    <el-col  :span="2"> &nbsp;</el-col>
                    <el-col :span="11">
                        <el-button  v-if="seckillAppInfo.app_name!='' " type="primary" class="" @click="showProduct()"   >修改商品</el-button>
                        <el-button   v-if="seckillAppInfo.app_name=='' " type="primary" class="" @click="showProduct()"   >获取商品</el-button>
                    </el-col>
                </el-form-item>

                <el-form-item label=" "  >&nbsp;</el-form-item>
                <el-form-item label="每日特价图片 " prop="publicity_img" >
                    <el-col :span="8">
                        <img :src="seckillAppInfo.publicity_img"  class="avatar" style="width: 100%"    >
                    </el-col>
                    <el-col  :span="2"> &nbsp;</el-col>
                    <el-col :span="11">
                        <el-button   v-if="seckillAppInfo.publicity_img!='' " type="primary"   @click="dialogVisibleToMaterial=true">修改图片</el-button>
                        <el-button  v-if="seckillAppInfo.publicity_img==''" type="primary"   @click="dialogVisibleToMaterial=true">获取图片</el-button>
                    </el-col>

                </el-form-item>
                <el-form-item label=" "  >&nbsp;</el-form-item>
                <el-form-item label="原价" prop="original_price">
                    <el-input-number v-model="seckillAppInfo.original_price" placeholder=" 0.01-10000"  :min="0.01" :max="10000" ></el-input-number>
                </el-form-item>
                <el-form-item label=" "  >&nbsp;</el-form-item>
                <el-form-item label="特价" prop="particularly_price">
                    <el-input-number v-model="seckillAppInfo.particularly_price"  placeholder=" 0.01-10000" :min="0.01" :max="10000" ></el-input-number>
                </el-form-item>
                <el-form-item label=" "  >&nbsp;</el-form-item>
                <el-form-item label="数量" prop="total_num" >
                    <el-input-number v-model="seckillAppInfo.total_num" placeholder="1-100000"  :min="1" :max="100000" ></el-input-number>
                </el-form-item>

                <!--   <el-button type="primary" class="" @click="submitForm('seckillAppInfo')" >保存</el-button>
                   <el-button type="primary" class="" @click="showProduct()"   >获取商品</el-button>
-->
            </el-form>
            <!-- 商品组件-->
            <br>
            <el-dialog
                    title="商品"
                    :visible.sync="dialogVisible":modal-append-to-body="false"
                    width="70%" top="30%"
            >
                <ProductPutWay  :modal-append-to-body="false" v-if="isShowProduct" @handle-selection-change="handleSelectionChange" :kioskNoList="kioskNoList" @close-product="closeProduct" :is_checkbox="is_checkbox"></ProductPutWay>
            </el-dialog>

            <!-- 选择素材 -->
            <el-dialog title="选择素材"
                        :visible.sync="dialogVisibleToMaterial" :modal-append-to-body="false"
                        width="70%" top="30%">
                 <MaterialSelect  :modal-append-to-body="false"  @listenAffirmResources="responseAffirmResources" :feature="feature"  ></MaterialSelect>

             </el-dialog>

            <el-form-item  style="margin-left: 16.5%" >
                <el-button type="primary" @click="lastStep()"
                           id="last_step" >上一步
                </el-button>
                <el-button  type="primary" class="" @click="submitForm('seckillAppInfo')" >保存修改</el-button>


                <el-button  v-if="act_status==-1" type="primary" class="" @click="startOrPaseAct('1')" >提交</el-button>
            </el-form-item>
        </div>
    </div>
</template>

<script>
    import ProductPutWay from "~/components/views/activity/ProductPutaWay.vue";
    import ElForm from "../../../../node_modules/element-ui/packages/form/src/form.vue";
    import ElFormItem from "../../../../node_modules/element-ui/packages/form/src/form-item.vue";
    import ElInput from "../../../../node_modules/element-ui/packages/input/src/input.vue";
    import MaterialSelect  from "~/components/views/material/MaterialSelect.vue";
    import ElCol from "element-ui/packages/col/src/col";
    export default {
        name: "SeckillApp",
        components: {
            ElCol,
            ElInput,
            ElFormItem,
            ElForm,
            ProductPutWay,
            MaterialSelect
        },
        props:
            ['actId' ],
        data() {
            return {
                // actId:"act1554775508625754578",
                isexpSecond: false,
                isorgsubmit: false,
                prodindex:0,
                acts:[],
                //dialog value
                dialogVisible:false,
                modal:false,
                ecxForm: {
                    choiceActExcode: '0',
                },
                actrules: {
                    choiceActExcode: [
                        {required: true, message: '请选择应用', trigger: 'blur'},
                    ],

                },
                kioskNoList:[

                ],
                seckillAppInfo:{
                    app_type_id:"seckill",
                    app_id:"",
                    original_price:0,
                    particularly_price:0,
                    price_unit:1,
                    publicity_img:"",
                    sku:"",
                    total_num:0,
                    app_name:"",
                    Image:"",
                    sku:"",
                },
                isShowProduct:false,
                is_checkbox:false,
                feature:"1080*300",
                dialogVisibleToMaterial:false,
                status_btn:0,
                act_status:-1,
                rules: {
                    original_price: [
                        { required: true, message: '原价不能为空', type: 'number',trigger: 'blur' },
                    ],
                    particularly_price: [
                        { required: true, message: '特价不能为空', type: 'number',trigger: 'blur'},
                    ],
                    total_num: [
                        { required: true, message: '数量不能为空', type: 'number',trigger: 'blur'},
                    ],
                    total_num: [
                        { required: true, message: '数量不能为空', type: 'number',trigger: 'blur'},

                    ],

                    sku: [{ required: true, message: '请选择商品', type: 'string',trigger: 'blur'},
                    ],
                    publicity_img:[{ required: true, message: '请选择素材', type: 'string',trigger: 'blur'}]
                }
            }
        },
        created(){
            this.findSeckillList();
            this.status_btn=this.$route.query.btnStatus;
            this.act_status=this.$route.query.act_status;
            this.findkioskNoList();
        },
        methods: {
            //===================================================================查询========================================================
            //查询已选择的设备
            findkioskNoList(){
                var url=this.admin_host+"/admin/activity/machine/find/list"
                // var url="http://localhost:8780/marketing/admin/activity/machine/find/list"
                this.$http.get(url+"?actId="+this.actId+"&iDisplayStart=0&iDisplayLength=50&tenantId="+this.getcookie('storeId'))
                    .then(response => {
                        this.kioskNoList=response.body.Data.machineList
                    })
            },

            //根据活动编号查询每日特价
            findSeckillList:function(){
                var url=this.admin_host+"/admin/activity/app/seckill/find/List"
                //异步请求查询每日特价
                this.$http.get(url+"?actId="+this.actId)
                    .then(response => {
                        if (response.body.Code === "200") {
                            var seckillList=response.body.Data.sekillList;
                            if(seckillList.length>0){
                                //循环每日特价
                                this.seckillAppInfo.app_id=seckillList[0].app_id;
                                this.seckillAppInfo.original_price=seckillList[0].original_price/100;
                                this.seckillAppInfo.particularly_price=seckillList[0].particularly_price/100;
                                this.seckillAppInfo.price_unit=seckillList[0].price_unit
                                this.seckillAppInfo.publicity_img=seckillList[0].publicity_img,
                                    this.seckillAppInfo.sku=seckillList[0].sku;
                                this.seckillAppInfo.total_num=seckillList[0].total_num;
                                this.seckillAppInfo.app_name=seckillList[0].app_name;
                                this.seckillAppInfo.sku=seckillList[0].sku;
                            }
                        }else   {this.$message({showClose: true, message: '操作异常', type: 'error' }); }
                    },function(response){ this.$message({ showClose: true, message: '网络异常',type: 'error'}); })
            },

            //新增、修改每日特价
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.saveSeckill();
                    } else {
                        //  console.log('error submit!!');
                        return false;
                    }
                });
            },

            saveSeckill:function() {

                if (this.actId=="") {
                    this.$message({
                        showClose: true,
                        message: '活动编号没有找到',
                        type: 'error'
                    });
                } else {
                    var params = {
                        appId: this.seckillAppInfo.app_id,
                        originalPrice: this.seckillAppInfo.original_price * 100,
                        particularlyPrice: this.seckillAppInfo.particularly_price * 100,
                        priceUnit: this.seckillAppInfo.price_unit,
                        publicityImg: this.seckillAppInfo.publicity_img,
                        sku: this.seckillAppInfo.sku,
                        totalNum: this.seckillAppInfo.total_num,
                        appName: this.seckillAppInfo.app_name,
                        appTypeId: this.seckillAppInfo.app_type_id,
                        sku: this.seckillAppInfo.sku,
                        actId: this.actId
                    };
                    var url = ""
                    if (this.seckillAppInfo.app_id == "") {
                        url = this.admin_host + "/admin/activity/app/seckill/save";
                    } else {
                        url = this.admin_host + "/admin/activity/app/seckill/modify";
                    }
                    //异步请求
                    this.$http.post(url, params)
                        .then(response => {
                            if (response.body.Code === "200") {
                                console.log(response.body)
                               /* if (this.seckillAppInfo.app_id == '') {
                                    this.startOrPaseAct(1);
                                }*/
                                this.$message({
                                    showClose: true,
                                    message: '操作成功',
                                    type: 'success'
                                });
                                this.findSeckillList();
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: '操作异常',
                                    type: 'error'
                                });
                            }
                        }, function (response) {
                            this.$message({
                                showClose: true,
                                message: '网络异常',
                                type: 'error'
                            });
                        })
                }
            },
            //修改活动状态
            startOrPaseAct(status){
                //数据请求
                this.loading = true
                var params = {actStatus:status,actId:this.actId};
                //异步请求
                this.$http.post(this.admin_host+"/admin/activity/modify/status",params)
                    .then(response => {
                        if (response.status === 200) {
                            if (response.body.Code == "200") {
                                if (status == 0) {
                                    this.$message({showClose: true, message: '暂停成功', type: 'success'});
                                }else if (status == 1) {
                                    this.$message({showClose: true, message: '开启成功', type: 'success'});
                                }
                            }else if (response.body.Code == "400") {
                                console.log("400")
                                this.$message({
                                    showClose: true,
                                    message: '参数错误',
                                    type: 'error'
                                });
                            }else if (response.body.Code == "500") {
                                console.log("500")
                                this.$message({
                                    showClose: true,
                                    message: '网络异常',
                                    type: 'error'
                                });
                            }
                        }
                    },function(response){
                        console.log("fail")
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'
                        });
                    })

            },
            handleSelectionChange:function(payload){
                if(payload!=null){
                    this.seckillAppInfo.original_price=payload.ppwPrice;
                    this.seckillAppInfo. Image=payload.Image
                    this.seckillAppInfo.app_name=payload.productName;
                    this.seckillAppInfo.sku=payload.SKU;
                }
                this.dialogVisible=false;
                /*   this.productList=[];
                  this.productList[0]=payload;
                 $.each(productList,function(i,item){
                      item.particularly_price=0;
                      item.total_num=0;
                      item.publicity_img="";
                      item.original_price=item.ppwPrice
                  })*/
                /* console.log(this.productList);*/
            },
            closeProduct:function(){
                this.isShowProduct=false;
                this.dialogVisible=false;
            },
            showProduct:function(){
                this.isShowProduct=true;
                this.dialogVisible=true;
            },
            /*卡片跳转*/
            sendMsgToParent: function (step, id) {
                this.$emit("listenToChildEventDef", step, id)
            },
            nextStep() {
                this.sendMsgToParent("5", this.actId)
            },
            lastStep() {
                this.sendMsgToParent("3", this.actId)
            },
            responseAffirmResources:function(ur){
                this.seckillAppInfo.publicity_img=ur;
            },
            responseAffirmResources:function(ur){
                this.seckillAppInfo.publicity_img=ur;
                this.dialogVisibleToMaterial=false;
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SeckillApp.vue?124ac4b0